import { useTranslation } from 'i18n';
import { Box, Typography } from 'ui';

export const NoDocument = () => {
  const { t } = useTranslation('orders');

  return (
    <Box
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        display: 'flex',
        height: '100%',
        p: 4,
      }}
    >
      <Typography variant="h4" align="center">
        {t('documentGeneration.documentDetails.notFound')}
      </Typography>
    </Box>
  );
};
